import React from "react";

// Bottom-left progress widget. Bottom right is the settings panel.
//
// The goal exists to give a session an ending — without one you stop when you
// get tired, which teaches you to associate the game with being tired. So this
// has to be visible while playing, not only on the dashboard.
//
// It keeps counting past the goal rather than disappearing at 100%: finishing
// is permission to stop, not an instruction to.
export default class DailyGoal extends React.Component {
  // Kept next to the widget that displays it so the cadence of the "on fire"
  // toasts and the flame on the counter can't drift apart. Mirrors
  // UserLanguage::WORDS_PER_MILESTONE.
  static WORDS_PER_MILESTONE = 50

  render() {
    const { goal, wordsPlayedToday } = this.props;

    if(!goal) {
      return null;
    }

    const met = wordsPlayedToday >= goal;
    const percent = Math.min(100, Math.round((wordsPlayedToday / goal) * 100));
    const beyond = wordsPlayedToday - goal;

    return (
      <div
        className="daily-goal-widget"
        style={{ position: 'fixed', bottom: 10, left: 10, zIndex: 999 }}
        title={met ? "Today's goal is done — anything more is a bonus" : `${goal - wordsPlayedToday} words to today's goal`}
      >
        <div className="card bg-dark text-white mb-0">
          <div className="card-body py-2 px-3">
            <div className="d-flex justify-content-between align-items-baseline">
              <small className="text-uppercase mr-3" style={{ letterSpacing: '0.03em' }}>
                <small>{met ? 'Daily goal done' : 'Daily goal'}</small>
              </small>
              <small>
                <strong>{wordsPlayedToday}</strong>
                <span className="text-muted"> / {goal}</span>
                {met && beyond > 0 && <span className="ml-1">&#x1F525;</span>}
              </small>
            </div>
            <div className="progress mt-1" style={{ height: 4, backgroundColor: 'rgba(255,255,255,0.2)' }}>
              <div
                className={'progress-bar' + (met ? ' bg-success' : '')}
                role="progressbar"
                style={{ width: percent + '%' }}
                aria-valuenow={wordsPlayedToday}
                aria-valuemin="0"
                aria-valuemax={goal}
              ></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
